import { useState,useEffect } from "react"
import {
  Box,
  Typography,
  Grid,
  Paper,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  Button
} from "@mui/material"
import { Close as XIcon } from "@mui/icons-material"

import  PartnersActivityWidget from "./partners-activity-widget"
import  ConnectionsWidget from "./connections-widget"
import MyPropertiesStatusWidget from "./my-properties-status-widget"
import MyRFPsStatusWidget from "./my-rfps-status-widget"
import SubmittedPropertiesStatusWidget from "./submitted-properties-status-widget"
import SubmittedRFPsStatusWidget from "./submitted-rfps-status-widget"
import  DealStatusWidget  from "./deals-status-widget"
import InefficienciesWidget from "./inefficiencies-widget"
import { TotalFeeEarnedWidget } from "./total-fee-earned-widget"
import { BusinessInsightsWidget } from "./business-insights-widget"
import { RatesWidget } from "./rates-widget"
import FilterListIcon from "@mui/icons-material/FilterList";
import LoaderWithLinearProgress from "../../app/components/LoaderWithLinearProgress";

const textColor = "#0d2561";

export default function ReportsPage() {
  const [selectedPeriod, setSelectedPeriod] = useState("day")

  const handlePeriodChange = (event: SelectChangeEvent) => {
    setSelectedPeriod(event.target.value as string)
  }

  const clearFilter = () => {
    setSelectedPeriod("day")
    setIsFilterActive(false);
  }

  const [loading, setLoading] = useState(true);
  const [isFilterActive,setIsFilterActive] = useState(false);

  const periods = [
    { value: "day", label: "Day" },
    { value: "week", label: "Week" },
    { value: "month", label: "Month" },
    { value: "3months", label: "3 Months" },
    { value: "6months", label: "6 Months" },
    { value: "1year", label: "1 Year" }
  ]
  const handleToggleFillter = () => {
    setIsFilterActive(true);
  };
  useEffect(() => {
     
    setLoading(false);
  }, []) // Run only once on mount
  if (loading) return <LoaderWithLinearProgress />;
  return (
    <Box sx={{ bgcolor: "grey.100", minHeight: "100vh", p: 4 }}>
      <Typography variant="h5" fontWeight="bold" color={textColor} mb={4}>
        My Reports
      </Typography>

      {/* Filter Section */}
       { isFilterActive ? (
      <Paper sx={{ p: 2, mb: 4, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 2 }}>
        <Box display="flex" alignItems="center" gap={2}>
          <Typography variant="body2" color="text.secondary">Filter by:</Typography>
          <Select
            value={selectedPeriod}
            onChange={handlePeriodChange}
            size="small"
            sx={{ width: 180 }}
          >
            {periods.map((period) => (
              <MenuItem key={period.value} value={period.value}>
                {period.label}
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Button
            variant="text"
            onClick={clearFilter}
            sx={{ color: 'text.secondary', textTransform: 'none' }}
            endIcon={<XIcon fontSize="small" />} // Add the XIcon as an endIcon
          >
          
          </Button>
        </Box>
        
      </Paper>):(<Box
            sx={{
              color: "#707070",
              display: "flex",
              justifyContent: "flex-end",
              margin: "10px",
              height: "55px",
            }}><Button
                onClick={handleToggleFillter}
                sx={{
                  "&:hover": {
                    backgroundColor: "#F5F5F5",
                  },
                }}
              >
                <FilterListIcon
                  sx={{
                    color: "rgba(112, 112, 112, 1)",
                    "&:hover": {
                      color: "rgba(13, 37, 97, 1)",
                    },
                  }}
                />
              </Button></Box>) }

      {/* Widget Grid */}
      <Grid container spacing={3}>
        {/* Row 1 */}
        <Grid item xs={12} lg={6}>
          <DealStatusWidget />
        </Grid>
         <Grid item xs={12} sm={6} md={6} lg={3}>
          <PartnersActivityWidget />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <ConnectionsWidget />
        </Grid> 

        {/* Row 2 */}
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <MyPropertiesStatusWidget />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <MyRFPsStatusWidget />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <SubmittedPropertiesStatusWidget />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <SubmittedRFPsStatusWidget />
        </Grid>

        {/* Row 3 */}
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <InefficienciesWidget />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <TotalFeeEarnedWidget />
        </Grid>

        {/* Row 4 */}
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <BusinessInsightsWidget />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <RatesWidget />
        </Grid>
      </Grid>
    </Box>
  )
}
